(function(){
    angular
        .module('app')
        .directive('datepicker', ngdatepicker);

        ngdatepicker.$inject = ['$timeout'];
        function ngdatepicker($timeout){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                language:"="
              },
            link: function (scope, element, attrs, ngModel) {
                return $timeout(function () {
                 	var format, dateObj;
                     format = (!attrs.dpFormat) ? 'dd-mm-yyyy' : attrs.dpFormat;
                     if (!attrs.initDate && !attrs.dpFormat) {
                        // If there is no initDate attribute than we will get todays date as the default
                        dateObj = new Date();
                        scope[attrs.ngModel] = dateObj.getDate() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getFullYear();
                     } else if (!attrs.initDate) {
                        // Otherwise set as the init date
                        scope[attrs.ngModel] = attrs.initDate;
                     } else {
                        // I could put some complex logic that changes the order of the date string I
                        // create from the dateObj based on the format, but I'll leave that for now
                        // Or I could switch case and limit the types of formats...
                     }
                     // Initialize the date-picker
                    var languageCode = "es";
                     console.log("lang",scope.language);
                    switch(scope.language){
                        case 3:
                            languageCode = "pt";
                        break;
                    }
                     console.log("lang",languageCode);

                     $(element).datepicker({
                        format: format,
                        autoclose: true,
                        language: languageCode,
                        weekStart: 1
                     }).on('changeDate', function(ev) {
                        // To me this looks cleaner than adding $apply(); after everything.
                        scope.$apply(function () {
                           ngModel.$setViewValue(ev.format(format));
                        });
                     });

                });
            }
          }
      }
})();